export default __webpack_public_path__ + "static/media/home.821c6b1a.webp";